export const LIST_GLOBAL_SETTINGS = 'LIST_GLOBAL_SETTINGS';
export const SAVE_GLOBAL_SETTING = 'SAVE_GLOBAL_SETTING';
export const LOAD_ORG_DATA = 'LOAD_ORG_DATA';
export const SET_GLOBAL_SETTING = 'SET_GLOBAL_SETTING';
export const SET_COMPANY_CODE = 'SET_COMPANY_CODE';